import moment from "moment";

export const formValidtion= (props) => {
    const {start,end,agenda,room,venue,name,field,setFormIsValid,setValidationMessage,setField}=props
    const today = moment(new Date()).startOf("day");
    if (moment(start) <= today && field ==="start") {
      setValidationMessage("Start Date cannot backdated");
      setFormIsValid(false);
    } 
    else if (moment(end) <= today&& field ==="end") {
      setValidationMessage("End Date cannot backdated");
      setFormIsValid(false);
    } 
   else  if (moment(start) > moment(end) && field ==="end") {
      setValidationMessage("End date must be greater than or equal start date ");
      setFormIsValid(false);
    } 
   else if (agenda?.trim() ==='' && field ==="agenda") {
      setValidationMessage("Agenda is required");
      setFormIsValid(false);
    } 
     else if (name?.trim() ==='' && field ==="name") {
      setValidationMessage("Name is required");
      setFormIsValid(false);
    } 
    else if (venue?.trim() ==='' && room?.trim() ===''&& field ==="venue") {
      setValidationMessage("Venue is required");
      setFormIsValid(false);
    } 
    else {
      setValidationMessage("");
      setField("");
      setFormIsValid(true);
    }
    }
